import e from "react";
//#region src/lib/context-providers/NewVersionContextProvider.ts
var t = e.createContext({
	newVersionAvailable: !1,
	newVersionInstalling: !1,
	highlightingNewVersion: !1,
	activateHighlight: void 0,
	triggerNewVersion: void 0
});
//#endregion
export { t as NewVersionAvailableContext };
